// Dashboard
import Dashboard from './views/dashboard/Dashboard'

// Clients
import AddClient from './views/clients/AddClient'
import EditClient from './views/clients/EditClient'
import ClientList from './views/clients/ClientList'
import ClientDetails from './views/clients/ClientDetails'

// Projects
import AddProject from './views/projects/AddProject'
import EditProject from './views/projects/EditProject'
import ProjectList from './views/projects/ProjectList'
import ProjectDetails from './views/projects/ProjectDetails'

// Invoices
import AddInvoice from './views/invoices/AddInvoice'
import EditInvoice from './views/invoices/EditInvoice'
import InvoiceList from './views/invoices/InvoiceList'
import InvoiceDetails from './views/invoices/InvoiceDetails'

// Expenses
import AddExpense from './views/expenses/AddExpense'
import EditExpense from './views/expenses/EditExpense'
import DuplicateExpense from './views/expenses/DuplicateExpense'
import ExpenseList from './views/expenses/ExpenseList'
import ExpenseDetails from './views/expenses/ExpenseDetails'

// Employees
import AddEmployee from './views/employees/AddEmployee'
import EditEmployee from './views/employees/EditEmployee'
import EmployeeList from './views/employees/EmployeeList'
import EmployeeDetails from './views/employees/EmployeeDetails'

// Assets
import AddAsset from './views/assets/AddAsset'
import EditAsset from './views/assets/EditAsset'
import AssetList from './views/assets/AssetList'
import AssetDetails from './views/assets/AssetDetails'

// General Settings
import GeneralSetting from './views/settings/GeneralSetting'
import AddGeneralSetting from './views/settings/AddGeneralSetting'
import EditGeneralSetting from './views/settings/EditGeneralSetting'

// Users
import AddUser from './views/users/AddUser'
import EditUser from './views/users/EditUser'
import UserList from './views/users/UserList'
import UserDetails from './views/users/UserDetails'

// Company Policy
import AddCompanyPolicy from './views/company-policy/AddCompanyPolicy'
import EditCompanyPolicy from './views/company-policy/EditCompanyPolicy'
import CompanyPolicyList from './views/company-policy/CompanyPolicyList'
import CompanyPolicyDetails from './views/company-policy/CompanyPolicyDetails'

// Policy Types
import AddPolicyType from './views/policy-types/AddPolicyType'
import EditPolicyType from './views/policy-types/EditPolicyType'
import PolicyTypeList from './views/policy-types/PolicyTypeList'
import PolicyTypeDetails from './views/policy-types/PolicyTypeDetails'

const routes = [
  { path: '/', name: 'Home', element: Dashboard, exact: true, },
  { path: '/dashboard', name: 'Dashboard', element: Dashboard, exact: true },
  { path: '/client/add', name: 'Add Client', element: AddClient },
  { path: '/client/edit/:id', name: 'Edit Client', element: EditClient },
  { path: '/client/list', name: 'Client List', element: ClientList },
  { path: '/client/details/:id', name: 'Client Details', element: ClientDetails },
  { path: '/project/add', name: 'Add Project', element: AddProject },
  { path: '/project/edit/:id', name: 'Edit Project', element: EditProject },
  { path: '/project/list', name: 'Project List', element: ProjectList },
  { path: '/project/details/:id', name: 'Project Detail', element: ProjectDetails },
  { path: '/invoice/add', name: 'Add Invoice', element: AddInvoice },
  { path: '/invoice/edit/:id', name: 'Edit Invoice', element: EditInvoice },
  { path: '/invoice/list', name: 'Invoice List', element: InvoiceList },
  { path: '/invoice/details/:id', name: 'Invoice Detail', element: InvoiceDetails },
  { path: '/expense/add', name: 'Add Expense', element: AddExpense },
  { path: '/expense/edit/:id', name: 'Edit Expense', element: EditExpense },
  { path: '/expense/duplicate/:id', name: 'Duplicate Expense', element: DuplicateExpense },
  { path: '/expense/list', name: 'Expense List', element: ExpenseList },
  { path: '/expense/details/:id', name: 'Expense Detail', element: ExpenseDetails },
  { path: '/employee/add', name: 'Add Employee', element: AddEmployee },
  { path: '/employee/edit/:id', name: 'Edit Employee', element: EditEmployee },
  { path: '/employee/list', name: 'Employee List', element: EmployeeList },
  { path: '/employee/details/:id', name: 'Employee Detail', element: EmployeeDetails },
  { path: '/asset/add', name: 'Add Asset', element: AddAsset },
  { path: '/asset/edit/:id', name: 'Edit Asset', element: EditAsset },
  { path: '/asset/list', name: 'Asset List', element: AssetList },
  { path: '/asset/details/:id', name: 'Asset Detail', element: AssetDetails },
  { path: '/generalsetting', name: 'General Setting', element: GeneralSetting },
  { path: '/generalsetting/add', name: 'Add General Setting', element: AddGeneralSetting },
  { path: '/generalsetting/edit/:id', name: 'Edit General Setting', element: EditGeneralSetting },
  { path: '/user/add', name: 'Add User', element: AddUser },
  { path: '/user/edit/:id', name: 'Edit User', element: EditUser },
  { path: '/user/list', name: 'User List', element: UserList },
  { path: '/user/details/:id', name: 'User Detail', element: UserDetails },
  { path: '/company-policy/add', name: 'Add Company Policy', element: AddCompanyPolicy },
  { path: '/company-policy/edit/:id', name: 'Edit Company Policy', element: EditCompanyPolicy },
  { path: '/company-policy/list', name: 'Company Policy List', element: CompanyPolicyList },
  { path: '/company-policy/details/:id', name: 'Company Policy Detail', element: CompanyPolicyDetails },
  { path: '/policy-type/add', name: 'Add Policy Type', element: AddPolicyType },
  { path: '/policy-type/edit/:id', name: 'Edit Policy Type', element: EditPolicyType },
  { path: '/policy-type/list', name: 'Policy Type List', element: PolicyTypeList },
  { path: '/policy-type/details/:id', name: 'Policy Type Detail', element: PolicyTypeDetails },
]

export default routes
